module.exports = __webpack_public_path__ + "static/media/trash_icon.7c628972.svg";